export default function ButtonCard({
  title,
  text,
  boldText,
  btnText,
  selected,
  onButtonClick,
}) {
  return (
    <div
      className={`border text-center hover:cursor-pointer shadow-lg ${
        selected ? "border-primary border-2 shadow-primary" : "border-dark/20"
      } rounded-4xl p-8 bg-gradient-to-br from-light to-white`}
      onClick={onButtonClick}
    >
      <span className="pointer-events-none">
        <h4 className="mb-0 font-sans">{title}</h4>

        {text && (
          <p className="my-4">
            {text}
            {boldText ? (
              <strong>
                <br />
                {boldText}
              </strong>
            ) : (
              ""
            )}
          </p>
        )}
        {btnText && (
          <>
            <hr />
            <span
              className={`btn !font-sans ${
                selected ? "btn-primary !border-primary !shadow-primary" : ""
              } block mt-8 !mb-0 !mr-0 !w-full`}
            >
              {btnText}
            </span>
          </>
        )}
      </span>
    </div>
  );
}
